/*eslint-disable */
import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Dropdown, Modal, Radio, Divider, Header, } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi } from "semantic-ui-react";
import { connect } from "react-redux";
import CreatAxios from '../axiosComponent/create';
import {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from 'react-i18next';
import { FIELD_IS_REQUIRED,} from '../../utils/validationConstant';
import cogoToast from "cogo-toast";
import MyState from '../apiInputs/myState';
const PreferredLocationEdit = ({ isSubmitting, handleSubmit, values, vendorId, setFieldValue, touched, errors, t, openModal, CloseModal }) => {
    
    
    return (
        <Modal
            onClose={CloseModal}
            open={openModal}
            size="small"
            className="p-overflow-initial"
        >
            <Modal.Header style={{ fontSize: "14px" }}>{t("preferred_locations.add.title")}</Modal.Header>
            <Modal.Content>
                <div className="ui form small">
                    <FormUi.Group inline={errors.locationIds ? false : true}>
                        <FormUi.Field width="4">
                            <label className="labelName">{t("preferred_locations.add.location.title")}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="locationIds" component={MyState} initialLoading={true} restrictSearch={true} multiple placeholder ={t("preferred_locations.add.location.placeholder")}/>
                        {touched.locationIds && errors.locationIds ? <small className="text-danger">{errors.locationIds}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>
                    {t("preferred_locations.add.cancel")}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {t("preferred_locations.add.ok")}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

const FormikPreferredLocationEdit = withFormik({
    
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        return {
            locationIds: []
        }
    },
    validationSchema: yup.object({
        locationIds: yup.string().required(FIELD_IS_REQUIRED)
    }),
    async handleSubmit(values, { props }) {
        if (props.vendorId && values.locationIds && values.locationIds.length) {
            let payload = {
                vendorId : props.vendorId,
                preferredLocationIds : [...props.locationIds , ...values.locationIds]
            }
            await CreatAxios({
                url: `transporterPreferredLocations`,
                payload,
            })
                .then((res) => {
                    if(res?.data?.status==200){
                        cogoToast.success(res?.data?.message || "Success", {hideAfter: 2 ,position: "top-right"});
                        window.location.reload()
                    }else{
                        cogoToast.error(res?.data?.message || "Failed to map the locations", {position: "top-right"});
                    }
                })
                .catch((err) => {
                    console.log(err);                    
                });
        }else{
            props.CloseModal()
        }
    }

})(PreferredLocationEdit)
export default connect(null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(translate('create_vendor')(FormikPreferredLocationEdit))
